
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-782846e2&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./VocabCardQuestion.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./VocabCardQuestion.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-782846e2!../../node_modules/vue-loader/lib/selector?type=template&index=0!./VocabCardQuestion.vue"),
  /* scopeId */
  "data-v-782846e2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/VocabCardQuestion.vue
// module id = 92
// module chunks = 2